import { http } from '@packet/management/src//api/http';
import type { GetOperationLogListRequest, GetOperationLogListResponse, OperationLog } from '../../DTO/operationLog';
import type { ApiResponse } from '../../DTO/common';

/**
 * 获取操作日志列表
 */
export const getOperationLogList = async (params: GetOperationLogListRequest): Promise<ApiResponse<GetOperationLogListResponse>> => {
  return http().get('/api/v1/operation_logs/list', params);
};

const nameMap: Record<string, string> = {
  users: '用户',
  create: '创建',
  organizations: '组织',
  update: '更新',
  delete: '删除',
  roles: '角色',
  permissions: '权限',
};

export const getOperationName = (uri: string) => {
  uri = uri.replace('/api/v1/', '');
  const names = uri.split('/');
  const transfer = names.map((v) => nameMap[v as keyof typeof nameMap] || v);
  return transfer.reverse().join(' ');
};

export const getOperationParse = (log: OperationLog) => {
  let error = '';
  let target = '';
  let res = null;
  let req = null;
  try {
    res = JSON.parse(log.response);
    if (res.code !== 0) error = res.error;
    req = JSON.parse(log.request);
    if (log.uri.startsWith('/api/v1/users')) target = req.username;
    if (log.uri.startsWith('/api/v1/organizations')) target = req.organization_name;
  } catch (e) {
    error = String(e);
  }
  return {
    ...log,
    optName: getOperationName(log.uri),
    error,
    target,
    res,
    req,
  };
};
